import { DateTime } from 'luxon';

export interface ProjectInfoDateRange {
  start: string;
  end: string;
  isTextEnd: boolean;
}

const toDateInputValue = (value: string): string | null => {
  if (!value.trim()) return '';
  const match = value.trim().match(/^(\d{4})[./-]\s*(\d{1,2})[./-]\s*(\d{1,2})\.?$/);
  if (!match) return null;
  const date = DateTime.fromObject({
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
  });
  return date.isValid && date.year > 0 ? date.toISODate() : null;
};

export const parseProjectInfoDateRange = (text: string): ProjectInfoDateRange | null => {
  const separator = /\s*[~–—]\s*|\s+-\s*|^\s*-\s*/.exec(text);
  const startText = separator ? text.slice(0, separator.index) : text;
  const endText = separator ? text.slice(separator.index + separator[0].length) : '';
  const start = toDateInputValue(startText);
  if (start === null) return null;
  const end = toDateInputValue(endText);
  return { start, end: end ?? endText, isTextEnd: end === null };
};

export const formatProjectInfoDateRange = ({ start, end, isTextEnd }: ProjectInfoDateRange): string => {
  const startText = start.replace(/-/g, '.');
  const endText = isTextEnd ? end : end.replace(/-/g, '.');
  return endText ? `${startText} - ${endText}`.trimStart() : startText;
};
